import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { DatePipe } from '@angular/common';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { fuseAnimations } from '@fuse/animations';
import { LazyLoadEvent, SelectItem } from 'primeng/primeng';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';

@Component({
  selector: 'app-opportunity-list',
  templateUrl: './opportunity-list.component.html',
  styleUrls: ['./opportunity-list.component.scss'],
  animations: fuseAnimations
})

export class OpportunityListComponent implements OnInit {

  cols: any[];
  profileId = '';
  currentuser: any;
  enquiryList = [];
  empRole = '';
  listOfColumns = [
    { field: 'position', header: 'S.No' },
    { field: 'enquiryName', header: 'Opportunity Name' },
    { field: 'clientName', header: 'Client Name' },
    { field: 'reporterName', header: 'Reporter Name' },
    { field: 'profileImageInfo', header: 'Reporting To' },
    { field: 'status', header: 'Status' },
    { field: 'requestedDate', header: 'Requested Date' },
    { field: 'submitedDate', header: 'Submit date' },
  ]
  listId: any;
  assigneeFilter: any;
  totalRecords: number;
  reportingToDD = [];
  reportingList = [];
  reportingToOptions = [];
  loadEventData: LazyLoadEvent;
  clientList = [];
  clientNameDD = [];
  clientNameOptions: SelectItem[];
  total: any;
  loading: boolean;
   

  constructor(
    private router: Router,
    private parseService: ParseService,
    private storageConfiguration: StorageConfiguration,
    private queryInterface: QueryInterface,
    private getReportingToService: GetReportingToService

  ) {
    this.currentuser = this.parseService.instance.User.current();
    this.profileId = this.currentuser.get('profile').id;
     
  }

  ngOnInit() {
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.getReportingTo();
    this.getEnquiryList();
    this.getClient();
  }

  async getEnquiryList() {
    this.queryInterface.executeQuery(this.parseService, 'Enquiry', [
      { condition: 'limit', value: 10 },
      { condition: 'descending', field: 'updatedAt' }]).then(async results => {
        this.enquiryList = this.loadResources(results, 0);
      });
  }

  loadResources(results, skip) {
    let result = [];
    let i = skip;
    results.forEach(async (element, index) => {
      let assignees = [];
      let assigneesId = [];
      let assigneesName = [];
      let datePipe = new DatePipe('en-US');
      let reporterId = element.get('requesterProfileId').id
      let status = element.get('status');
      await this.getRelationsAssignee(element.get('assignees')).then(relationResult => {
        relationResult.forEach(res => {
          assignees.push({
            id: res.id,
            username: res.get('username'),
            image: res.get('profileImageInfo').url
          });
          assigneesId.push(res.id);
          assigneesName.push(res.get('username'));
        });
      });
      let enquiryInfo = {
        objectId: element.id,
        enquiryName: element.get('enquiryName'),
        clientName: element.get('client') ? element.get('client').get('companyInfo').firstName + ' ' + element.get('client').get('companyInfo').lastName : '',
        client: element.get('client') ? element.get('client').id : '',
        reporterName: element.get('requesterProfileId') ? element.get('requesterProfileId').get('firstName') + ' ' +
          element.get('requesterProfileId').get('lastName') : '',
        requesterProfileId: element.get('requesterProfileId') ? element.get('requesterProfileId').id : '',
        profileImageInfo: element.get('requesterProfileId').get('profileImageInfo').url,
        assignees: assigneesName,
        status: status,
        requestedDate: datePipe.transform(element.get('requestedDate'), 'MM/dd/yyyy'),
        submitedDate: datePipe.transform(element.get('lastDateToSubmit'), 'MM/dd/yyyy')
      }
      if (this.empRole != 'Admin') {
        if (this.profileId == reporterId) {
          let itemIndex = result.indexOf(enquiryInfo);
          if (itemIndex == -1) {
            result.push(enquiryInfo);
            // this.totalRecords = result.length;
          }
        }
        this.assigneeFilter = assigneesId.filter(x => x == this.profileId);
        if (this.assigneeFilter.length > 0) {
          let itemIndex = result.indexOf(enquiryInfo);
          if (itemIndex == -1) {
            result.push(enquiryInfo);
            // this.totalRecords = result.length;
          }
        }
      }
      else {
        let itemIndex = result.indexOf(enquiryInfo);
        if (itemIndex == -1) {
          result.push(enquiryInfo);
          // this.totalRecords = result.length;
        }
      }
    });
    return result;
  }

  /*
  ** ==========================================================
  ** Lazy load
  ** ==========================================================
  */

  async onLazyLoadResources(event: LazyLoadEvent) {
    this.loadEventData = event;
    let condition = [];
    const filter: any = event.filters;
    if (!filter) {
      const skip: number = event.first;
      condition.push({ condition: 'skip', value: event.first }, { condition: 'descending', field: 'updatedAt' });
      this.total = await this.getTotalRecordCount(condition);
      this.lazyLoadAddResources(condition, skip, event.rows);
    } else if (event.sortField) {
      const skip: number = event.first;
      let field = event.sortField;
      let sortOrder = event.sortOrder == 1 ? 'descending' : 'ascending';
      // tslint:disable-next-line:forin
      for (let key in filter) {
        let filterValue = filter[key].value;
        if (!(filterValue.length < 1)) {
          if (key == 'client' || key == 'requesterProfileId') {
            condition.push({
              condition: 'containedIn',
              field: key,
              value: filter[key].value
            });
          }
          if (key != 'client' && key != 'requesterProfileId') {
            filterValue = filter[key].value.replace(/\b\w/g, l => l.toUpperCase());
            condition.push({ condition: 'contains', field: key, value: filterValue });
          }
        }
      }
      let sortCondition = {};
      if (sortOrder == 'ascending') {
        sortCondition = { condition: sortOrder, value: field };
      } else {
        sortCondition = { condition: sortOrder, field: field };
      }
      condition.push(
        sortCondition,
        { condition: 'skip', value: event.first });
      this.total = await this.getTotalRecordCount(condition);
      if (this.total < event.first) {
        event.first = 0;
      }
      this.lazyLoadAddResources(condition, skip, event.rows);
    } else {
      // tslint:disable-next-line:forin
      for (let key in filter) {
        let filterValue = filter[key].value;
        if (!(filterValue.length < 1)) {
          if (key == 'client' || key == 'requesterProfileId') {
            condition.push({
              condition: 'containedIn',
              field: key,
              value: filter[key].value
            });
          }
          if (key != 'client' && key != 'requesterProfileId') {
            filterValue = filter[key].value.replace(/\b\w/g, l => l.toUpperCase());
            condition.push({ condition: 'contains', field: key, value: filterValue });
          }
        }
      }
      condition.push({ condition: 'skip', value: event.first });
      this.total = await this.getTotalRecordCount(condition);
      if (this.total < event.first) {
        event.first = 0;
      }
      this.lazyLoadAddResources(condition, event.first, event.rows);
    }
  }

  lazyLoadAddResources(condition, skip, limit) {
    condition.push({ condition: 'limit', value: limit }, { condition: 'descending', field: 'updatedAt' });
    this.queryInterface.executeQuery(this.parseService, 'Enquiry', condition).then(results => {
      this.enquiryList = this.loadResources(results, skip);
    });
  }

  async getRelationsAssignee(result) {
    var relationResult = [];
    await result
      .query()
      .each(function (obj) {
        relationResult.push(obj);
      });
    return relationResult;
  }

  async getReportingTo() {
    await this.getReportingToService.getReportingTo().then(res => {
      this.reportingToOptions = res;
    });
  }

  uniqBy(a, key) {
    var index = [];
    return a.filter(function (item) {
      var k = key(item);
      return index.indexOf(k) >= 0 ? false : index.push(k);
    });
  }

  updateEnquiryList(event) {
    this.router.navigate(['project-enquiry', { id: event }]);
  }

  createEnquiry() {
    this.router.navigate(['project-enquiry']);
  }

  /*
  ** ==========================================================
  ** Get total records
  ** ==========================================================
  */
  getTotalRecordCount(condition) {
    return this.queryInterface.getQueryCount(this.parseService, 'Enquiry', condition);
  }

  getResourcesCount() {
    return this.queryInterface.getQueryCount(this.parseService, 'Enquiry', []);
  }


  /*
  ** ==========================================================
  ** Get Client Details
  ** ==========================================================
  */
  getClient() {
    let result = [];
    this.queryInterface.executeQuery(this.parseService, 'Client', []).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let clientNameInfo = JSON.parse(jsonText);
        result.push({ name: clientNameInfo.companyInfo.firstName.concat(' ' + clientNameInfo.companyInfo.lastName), id: clientNameInfo.objectId });
      }
      this.clientNameDD = result;
      this.clientNameDD = this.clientNameDD.sort((a, b) => a.name.localeCompare(b.name));
      this.clientNameOptions = this.bindClientDropDown(this.clientNameDD);
    });
  }

  bindClientDropDown(array: any[]): any[] {
    const dropDownItem = [];
    array.forEach(a => {
      dropDownItem.push({ label: a.name, value: a.id });
    });
    return dropDownItem;
  }


}



